<template>
  <v-dialog
    v-if="isDialog"
    scrollable
    fullscreen
    hide-overlay
    v-model="isDialog"
    @click:outside="closeDialog"
    width="450px"
  >
    <v-card max-height="500px">
      <v-card-title>
        <v-toolbar dark color="#2B2118">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ feature.sample_name_original }} ({{
              feature.sample_name_apd
            }})</v-toolbar-title
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row align-content="center" justify="center">
            <v-col
              cols="12"
              justify="center"
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
            >
              <p>Sample Name (Original): {{ feature.sample_name_original }}</p>
              <p>Sample Name (APD): {{ feature.sample_name_apd }}</p>
              <p>
                Location: {{ feature.country_name }}
                {{ feature.region_name ? " - " + feature.region_name : "" }}
              </p>
              <p>
                Coordinates:
                {{ feature.latitude + "° N, " + feature.longitude + "° E" }}
              </p>
              <p>
                Altitude:
                {{
                  feature.altitude ? feature.geo.geometry.coordinates + " m" : "Not Available"
                }}
              </p>
              <p>Sample Type: {{ feature.sample_type_name }}</p>
              <p>
                Author(s):
                {{ feature.author ? feature.author : "Not Available" }}
              </p>
              <p>
                Dataset:
                {{
                  feature.count_file_title
                    ? feature.count_file_title
                    : "Not Available"
                }}
              </p>
              <p>
                Bibliography:
                {{
                  feature.bibliography ? feature.bibliography : "Not Available"
                }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn disabled>
          <v-icon>mdi-download</v-icon>
          Dowload Data
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
export default {
  props: ["dialog", "feature"],
  data() {
    return {
      mapDiv: 0,
      center: [6.7832, +14.5085],
    };
  },

  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    setupLeafletMap() {
      let DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
      });

      L.Marker.prototype.options.icon = DefaultIcon;
      this.mapDiv = L.map("eiiContainer").setView(this.center, 3);
      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/satellite-v9",
          accessToken:
            "pk.eyJ1IjoiYWxlbW9yaSIsImEiOiJja2U0MmdkZHowcDFyMnhwZGc0dWgxNTIwIn0.AZJzeynr-RH04CF2OEuAoQ",
        }
      ).addTo(this.mapDiv);
    },
  },
  computed: {
    isDialog() {
      return this.dialog;
    },
  },
  created() {
    this.setupLeafletMap();
  },
};
</script>

<style scoped>
#eiiContainer {
  width: 300px;
  z-index: 0;
  height: 300px;
}
</style>
